export const StringSimilarity = (firstString = "", secondString = "") => {
  let firstStringChars = [];
  let secondStringChars = [];

  function findMatchingIndices(arr1, arr2) {
    const indices = [];

    for (let i = 0; i < arr1.length; i++) {
      const element1 = arr1[i];
      for (let j = 0; j < arr2.length; j++) {
        const element2 = arr2[j];
        if (element1 === element2) {
          indices.push(i);
          break;
        }
      }
    }

    return indices;
  }

  function calculatePercentage(arr1, arr2) {
    let length1 = arr1.length;
    let length2 = arr2.length;

    let percentage = Math.min(length1, length2) / Math.max(length1, length2);
    return percentage;
  }

  for (let i = 0; i < firstString.length; i++) {
    firstStringChars.push(firstString[i]);
  }
  for (let i = 0; i < secondString.length; i++) {
    secondStringChars.push(secondString[i]);
  }

  return calculatePercentage(
    firstStringChars,
    findMatchingIndices(firstStringChars, secondStringChars)
  );
};
